import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager';

export const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;
export const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
const FLYOUT_MESSAGE_LOCAL_STORAGE_PREFIX = 'flyout.message';
export const DISABLE_FLYOUT_MESSAGE_KEY = `${FLYOUT_MESSAGE_LOCAL_STORAGE_PREFIX}.disabled`;
export const FLYOUT_DATE_LAST_SHOWN_KEY = `${FLYOUT_MESSAGE_LOCAL_STORAGE_PREFIX}.date.last.shown`;

export const setFlyoutMessageDisabled = () => {
	localStorage.setItem(DISABLE_FLYOUT_MESSAGE_KEY, true, ONE_YEAR_IN_SECONDS);
};

export const getFlyoutMessageDisabledValue = () =>
	localStorage.getItemAsBoolean(DISABLE_FLYOUT_MESSAGE_KEY);

export const setFlyoutDateLastShown = () => {
	const currentDate = new Date().toLocaleDateString();
	localStorage.setItem(FLYOUT_DATE_LAST_SHOWN_KEY, currentDate, ONE_DAY_IN_SECONDS);
};

export const getFlyoutDateLastShownValue = () => localStorage.getItem(FLYOUT_DATE_LAST_SHOWN_KEY);
